import { MDBAlert, MDBBtn, MDBDatatable, MDBIcon, MDBInput } from "mdb-react-ui-kit";
import { useEffect, useRef, useState } from "react";
import { useForm } from "react-hook-form";
import { useTranslation } from "react-i18next";
import { Tooltip } from "react-tooltip";
import { getMisc, updateRole } from "../../../apiclients/streamsapi_bridge";
import PopupLoader from "../../../views/popups/PopupLoader";
import { AddRemoveUsers } from "../../../views/popups/users/AddRemoveUsers";
import SaveChanges from "../../topviews/saveCancel";
import PopupLoaderNew from "../../../views/popups/PopupLoaderNew";
import AddToUsers from "../../../views/popups/misc/AddToUsers";
import TopSuccess from "../../header/TopSuccess";
import TopMessage from "../../header/TopMessage";
import RemoveToUser from "../../../views/popups/misc/RemoveToUser";
import { customSearch, useAutoFocusSearchAfterLoads } from "../../CustomSearchUtil/CustomSearch";
import UIConstant from "../../../apiclients/UIConstant";

export function RoleUsers({ existingUsers, roleInfo, isDisabled, setErrorMessage, setHasPrevilege, setEdited, roleName,setUserCount,basicActive}) {
    const { t, i18n } = useTranslation();
    const [roleDetails, setRoleDetails] = useState(roleInfo);
    const [selectedAdminUsers, setSelectedAdminUsers] = useState([]);
    const [removedAdminUsers, setRemovedAdminUsers] = useState([]);
    const [addedAdminUsers, setaddedAdminUsers] = useState([]);
    const [alreadyExistedUsers, setAlreadyExistedUsers] = useState([]);
    const [refreshComponent, setRefreshComponent] = useState(false);
    const [roleUpdated, setRoleUpdated] = useState(false);
    const [message, setMessage] = useState("");
    const [internalError, setInternalError] = useState(false);
    const [sourceUsers, setSourceUsers] = useState([]);
    const [updateUsers, setUpdateUsers] = useState([]);
    const [isAddedUsers, setIsAddedUsers] = useState(false);
    const [successMessage, setSuccessMessage] = useState("");

    const [searchValue, setsearchValue] = useState("");
    const [filteredRows, setFilteredRows] = useState([]);
    const [dataLoaded, setDataLoaded] = useState(false);
    const searchRef = useRef(null);


    //React Hook form.
    const { register, setValue, formState: { isDirty }, handleSubmit, reset } = useForm();

    const [AddUser, setAddUser] = useState(false);
    const closeTogglePopup = () => setAddUser(!AddUser);
    const addUserRef = useRef(null);
    const [isLoading, setisLoading] = useState(false);
    const [isdeleteUser, setIsDeleteUser] = useState(false);
    const [isdelete, setIsDelete] = useState(false);
    const dUtogglePopup = () => setIsDelete(!isdelete);
    useAutoFocusSearchAfterLoads(dataLoaded,setDataLoaded,searchRef,basicActive)

    useEffect(() => {
        if (successMessage) {
            setTimeout(() => {
                setSuccessMessage(""); // Clear the success message in the parent component
            }, 5000);
        }
    }, [successMessage]);

    function handleClick() {
        addUserRef.current.click();
    }

    useEffect(() => {
        setEdited(isDirty)
    }, [isDirty])

    const onSaveChanges = async (data) => {
        try {
            if (isDirty) {
                let modifiedData = {
                    reqid: 27,
                    siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                    logined_user: JSON.parse(sessionStorage.getItem("admin_session")).logined_user,
                    roles_id: roleInfo.id,
                    role: roleInfo.role,
                    ...(data.role_users?.length > 0 && { role_users: data.role_users.map(obj => obj.agentid) }),
                    ...(data.delete_role_users?.length > 0 && { delete_role_users: data.delete_role_users.map(obj => obj.agentid) })
                };
                //sending the request to API service to update.
                let response = await updateRole(modifiedData);
                let resdata = await response.json();
                if (response.status === 200) {
                    setMessage(resdata.message); // success pop up message.
                    setRoleUpdated(true); // enabling sucesss popup
                    processUserDtlsFraming(selectedAdminUsers);
                    resetHookForm();
                } else if (response.status === 400) {
                    if (resdata.message?.errors) {
                        resdata.message.errors.forEach((err) => {
                            if (err.param_name === "logined_user") {
                                setHasPrevilege(true)
                                setErrorMessage(err.message)
                                reset();
                            }
                        });
                    }
                }
                else {
                    setInternalError(true);
                }
            }
        } catch (e) {
            console.log(`Unable to send update Role to API:${e}`);
            setInternalError(true);
        }
    }


    useEffect(() => {
        async function fetchData() {
            let UserList = [],
                apiResponse = {};
            apiResponse = await getMisc(
                JSON.parse(sessionStorage.getItem("admin_session")).siteid,
                { misc: ["role_users"] }
            );

            if (apiResponse.status === 200) {
                const Users = await apiResponse.json();
                console.log(`SMS Group UserList ::::: ${JSON.stringify(Users)}`);

                UserList = Users.misc.users ?? [];
                console.log(`SMS Group UserList 11111::::: ${JSON.stringify(UserList)}`);

                setSourceUsers(UserList);
            } else {
            }
        }


        fetchData();
        setDataLoaded(true)

    }, []);


    const handleDelete = (event, infoObj) => {
        event.preventDefault();
        dUtogglePopup();
        setUpdateUsers([infoObj]);
    };

    useEffect(() => {
        if (updateUsers.length > 0 && isAddedUsers) {
            updateTheUser("role_users");
            setIsAddedUsers(false);
        }
    }, [updateUsers, isAddedUsers]);

    useEffect(() => {
        if (updateUsers.length > 0 && isdeleteUser) {
            updateTheUser("delete_role_users");
            setIsDeleteUser(false);
        }
    }, [updateUsers, isdeleteUser]);

    async function updateTheUser(fieldName) {
        setInternalError(false);
        const agentids = new Set(updateUsers.map((item) => item.agentid));
        let update = {};

        let saverep;

        update = {
            reqid: 27,
            siteid: JSON.parse(sessionStorage.getItem("admin_session")).siteid,
            logined_user: JSON.parse(sessionStorage.getItem("admin_session")).logined_user,
            roles_id: roleInfo.id,
            role: roleInfo.role,
            [fieldName]: Array.from(agentids),
        };
        console.log("SMS Add Remove Users Request ::: " + JSON.stringify(update));
        saverep = await updateRole(update);

        console.log(saverep);
        let saverepeMsg = await saverep.json();
        const usernames = new Set(updateUsers.map((item) => item.name));
        const users = Array.from(usernames).join(", ");
        if (saverepeMsg.status && saverepeMsg.status == "success") {
            if (fieldName === "role_users") {
                const updatedUsers = [...selectedAdminUsers, ...updateUsers];
                // setSelectedAdminUsers(updatedUsers);
                setUserCount(updatedUsers.length)
                processUserDtlsFraming(updatedUsers);
                setSuccessMessage(saverepeMsg.message);
            } else {
                const filterExtension = new Set(
                    updateUsers.map((item) => item.agentid)
                );
                const filterUsers = selectedAdminUsers.filter(
                    (item) => !filterExtension.has(item.agentid)
                );
                setUserCount(filterUsers.length)

                // setSelectedAdminUsers(filterUsers);
                processUserDtlsFraming(filterUsers);

                setSuccessMessage(saverepeMsg.message);
            }
        } else {
            if (fieldName === "delete_role_users") {
                const filterExtension = new Set(
                    updateUsers.map((item) => item.agentid)
                );
                let modifyUser = selectedAdminUsers.filter(
                    (item) => !filterExtension.has(item.agentid)
                );
                modifyUser = [...modifyUser, ...updateUsers];
                // setSelectedAdminUsers(modifyUser);
                processUserDtlsFraming(modifyUser);

                setInternalError(true);
            }
        }
    }
    
    function processUserDtlsFraming(UsersInfo) {
        let upatedData = UsersInfo?.map((infoObj) => ({
            ...infoObj, delete: (
                <>
                    {/* <i
                        className="fas fa-xmark text-primary"
                        href="#"
                        onClick={(e) => deleteSelectedUser(e, infoObj)}
                        defaultValue={infoObj.agentid}
                        target="_new"
                    /> */}

                    <div className="d-flex align-items-center justify-content-center">
                        <div className="custom-hover-bg p-1 cursor-pointer deleteToolTip"
                            onClick={(e) => handleDelete(e, infoObj)}
                            defaultValue={infoObj.agentid}>
                            <MDBIcon fas icon="times" color="primary" className="mx-2 fs-5" />
                        </div>
                    </div>

                </>
            )
        })
        ) ?? [];
        setSelectedAdminUsers(upatedData);
        setFilteredRows(upatedData)
        setDataLoaded(true)
    }


    useEffect(() => {
        if (existingUsers?.length > 0) {
            processUserDtlsFraming(existingUsers);
            setAlreadyExistedUsers(existingUsers);
        }
    }, [existingUsers]);
    useEffect(() => {
        if (refreshComponent) {
            setRefreshComponent(false);
            processUserDtlsFraming(selectedAdminUsers);
            //checkDataModified();
        }
    }, [refreshComponent]);

    // function checkDataModified() {
    //     if (addedAdminUsers?.length !== 0 || removedAdminUsers?.length !== 0) {
    //         if (removedAdminUsers?.length > 0 || alreadyExistedUsers?.length !== addedAdminUsers?.length) {
    //             setValue("role_users", addedAdminUsers, { shouldDirty: true });
    //             setValue("delete_role_users", removedAdminUsers, { shouldDirty: true });
    //         } else {
    //             let listAgents = alreadyExistedUsers.map(obj => obj.agentid);
    //             for (let index = 0; index < addedAdminUsers?.length; index++) {
    //                 if (!listAgents.includes(addedAdminUsers[index].agentid)) {
    //                     setValue("role_users", addedAdminUsers, { shouldDirty: true });
    //                     setValue("delete_role_users", removedAdminUsers, { shouldDirty: true });
    //                     break;
    //                 }
    //             }
    //         }
    //     }
    // }
    // useEffect(() => {
    //     checkDataModified();
    // }, [addedAdminUsers, alreadyExistedUsers, removedAdminUsers, selectedAdminUsers]);

    // function deleteSelectedUser(event, roleObj) {
    //     event.preventDefault();
    //     event.stopPropagation();
    //     setSelectedAdminUsers((prevUsers) => {
    //         const updatedAdminUsers = prevUsers.filter((user) => user.agentid !== roleObj.agentid);
    //         return updatedAdminUsers;
    //     });
    //     setRemovedAdminUsers((prevUsers) => {
    //         if (prevUsers?.length == 0 || !(prevUsers.filter((user) => user.agentid).includes(roleObj.agentid))) {
    //             prevUsers.push(roleObj);
    //         }
    //         return prevUsers;
    //     });
    //     //checkDataModified();
    // }
    const onCloseChanges = () => {
        processUserDtlsFraming(alreadyExistedUsers);
        resetHookForm();
    }

    const resetHookForm = () => {
        setRemovedAdminUsers([]);
        setaddedAdminUsers([]);
        reset();
    }
    //basic columnn information.
    let columnsInfo = [
        { label: "User", field: "name", sort: true, width: "150px" },
        { label: "Email", field: "email", sort: true },
        { label: "Remove", field: "delete", sort: false },
    ];




    const handleManualSearch = (searchValue) => {
        setsearchValue(searchValue);
        const filteredUsers = customSearch(selectedAdminUsers, searchValue, UIConstant.ROLE_USERS);

        setFilteredRows(filteredUsers);
    };

    return (
        <>
            <div className={isDisabled && 'disabled-form cursor-notAllowed'}
                title={isDisabled && "Do not have previlege to edit role"}
            >
                <div className="d-flex justify-content-between actionbar">
                    <MDBBtn className="ms-2" onClick={closeTogglePopup}>
                        <MDBIcon fas icon="plus" size="sm" />  {`Add ${roleName}`}
                    </MDBBtn>
                </div>


                <div className='mb-2 mt-2 position-relative w-auto'>
                    <MDBInput ref={searchRef} label="Search" value={searchValue}  onChange={(e) => handleManualSearch(e.target.value)} />
                    <MDBIcon fas icon="search" className='MDBDatatable-Search' />
                </div>
                <div className={isDisabled ? 'disabled-form' : 'w-100 roleeditDatatable'}>
                    <MDBDatatable className="actioncolumn" 
                        key={searchValue}
                        entries={50}
                        sortField="User"
                        maxHeight="63vh"
                        sortOrder="asc"
                        searchInputProps={[]}
                        data={{
                            columns: columnsInfo,
                            rows: filteredRows
                        }}
                        hover
                    />
                </div>
            </div>
            {isDirty && (
                <SaveChanges
                    onClose={onCloseChanges}
                    onSave={(e) => {
                        e.preventDefault();
                        handleSubmit(onSaveChanges)();
                    }}
                />
            )}
            {roleUpdated && (
                <MDBAlert
                    open
                    className="alert-center"
                    color="success"
                    autohide
                    position="bottom-right"
                    delay={5000}
                    onClose={() => setRoleUpdated(false)}
                >
                    <i className="fas fa-check-circle me-3"></i>
                    <span className="alert-msg">{message}</span>
                </MDBAlert>
            )}
            {internalError && (<MDBAlert
                open
                className="alert-center"
                color="danger"
                autohide
                position="bottom-right"
                delay={5000}
                onClose={() => setInternalError(false)}
            >Internal Server Error</MDBAlert>)}

            {/* {AddUser && (
                <PopupLoader
                    title={t("AddAdminRole")}
                    content={<AddRemoveUsers
                        onClose={closeTogglePopup}
                        alreadyExistedUsers={alreadyExistedUsers}
                        selectedUsers={selectedAdminUsers}
                        setSelectedAdminUsers={setSelectedAdminUsers}
                        addUsers={setaddedAdminUsers}
                        removedUsers={setRemovedAdminUsers}
                        refresh={setRefreshComponent}
                        module='Role'
                    />}
                    onShow={setAddUser}
                    onClose={closeTogglePopup}
                />
            )} */}

            {AddUser && (
                <PopupLoaderNew
                    title={t("AddAdminRole")}
                    content={
                        <AddToUsers
                            onClose={closeTogglePopup}
                            selectedUsers={selectedAdminUsers}
                            setUpdateUsers={setUpdateUsers}
                            setIsAddedUsers={setIsAddedUsers}
                            sourceUsers={sourceUsers}
                            ref={addUserRef}
                            setIsloading={setisLoading}
                        />
                    }
                    onShow={setAddUser}
                    onClose={closeTogglePopup}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={2}
                />
            )}

            {successMessage && (
                <>
                    <TopSuccess>
                        <TopMessage successMessage={successMessage} />
                    </TopSuccess>
                </>
            )}

            {isdelete && (
                <PopupLoaderNew
                    title={"Remove User"}
                    content={
                        <RemoveToUser
                            setIsDeleteUser={setIsDeleteUser}
                            onClose={dUtogglePopup}
                            ref={addUserRef}
                            setIsloading={setisLoading}
                        />
                    }
                    onShow={setIsDelete}
                    onClose={dUtogglePopup}
                    onSave={handleClick}
                    isloading={isLoading}
                    flag={4}
                />
            )}
            <Tooltip anchorSelect=".deleteToolTip" place="top" className="exampleTooltip">
                Remove
            </Tooltip>
        </>
    );

}